import { type ReactElement } from 'react';
import { MOBILE_TABS, type MobileTabId } from './mobileTabRegistry';

export type { MobileTabId };

export function MobileTabBar({
  active,
  onChange,
}: {
  active: MobileTabId;
  onChange: (id: MobileTabId) => void;
}): ReactElement {
  /*
   * Tier-gated tabs are shown, not hidden (2026-09-10).
   *
   * Hiding them meant a Zeroday user had no way to learn Ticker Explorer
   * exists; the ask is that they see it and meet the upgrade prompt on tap.
   * `MobileWorkspace` wraps each gated tab in `ViewGate`, so opening one
   * renders the upgrade card instead of the page — the lock is enforced at the
   * destination, and this bar is free to advertise it.
   *
   * Matches desktop, where `Navigation` has never filtered on entitlement.
   */
  const tabs = MOBILE_TABS;

  return (
    <nav className="sr-mobile-tabbar" role="tablist" aria-label="Main">
      {tabs.map((t) => {
        const Icon = t.icon;
        const selected = active === t.id;
        return (
          <button
            key={t.id}
            role="tab"
            type="button"
            className="sr-mobile-tab"
            aria-selected={selected}
            disabled={!t.enabled}
            onClick={() => onChange(t.id)}
          >
            <Icon className="sr-mobile-tab-icon" />
            <span>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
